import { formatPostCode } from '@avantia/client-and-server-utilities';
import { HpTextInputControlProps, TextInputControl } from './textInputControl';

export type HpPostCodeInputControlProps = HpTextInputControlProps;

export function PostCodeInputControl(props: HpPostCodeInputControlProps): JSX.Element {
  const currProps = { ...props };
  currProps.formatter = {
    undo: (val, ui, eventType): string => {
      return eventType === 'blur' ? formatPostCode(val as string) : (val as string);
    }
  };
  return TextInputControl(currProps);
}
